import { render, staticRenderFns } from "./DisableItem.vue?vue&type=template&id=ed042534&scoped=true&"
import script from "./DisableItem.vue?vue&type=script&lang=js&"
export * from "./DisableItem.vue?vue&type=script&lang=js&"
import style0 from "./DisableItem.vue?vue&type=style&index=0&id=ed042534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed042534",
  null
  
)

export default component.exports